<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-23 
-->
<template>
  <div :class="['fixed-btns']">
    <div class="item" v-for="item,index in btnList" :key="index" @click="clickBanner(item, 'right-btn')">
      <div class="iconfont-wrap">
        <i class="iconfont" v-if="index == 0">&#xe6e2;</i>
        <i class="iconfont" v-if="index == 1">&#xe6e4;</i>
        <i class="iconfont" v-if="index == 2" style="font-size: .26rem">&#xe6e5;</i>
        <i class="iconfont" v-if="index == 3">&#xe6e3;</i>
      </div>
      <div class="font">{{item.description}}</div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['clickBanner'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  data() {
    return {
      isScroll: false,
    }
  },
  methods: {},
}
</script>
<style lang='stylus' scoped>
.fixed-btns
  position fixed
  width 1.29rem
  right 0
  bottom 30%
  cursor pointer
  z-index 998
  transition all 0.3s
  &.on
    right -0.59rem
  & > div
    position relative
    width 1.29rem
    height 0.7rem
    display flex
    align-items center
    background-color #4E77DF
    padding 0.07rem 0 0.07rem 0.07rem
    border-radius 0.35rem 0 0 0.35rem
    transition all 0.3s
    &:hover
      background-color #FA5A00
    & + div
      margin-top 0.2rem
    .iconfont-wrap
      display flex
      align-items center
      justify-content center
      max-width 0.56rem
      min-width 0.56rem
      height 0.56rem
      background #FFFFFF
      border-radius 50%
      overflow hidden
      line-height 1
      i.iconfont
        color #FA5A00
        font-size 0.3rem
    .font
      color #fff
      font-size 0.24rem
      line-height 0.28rem
      display flex
      align-items center
      justify-content center
      text-align center
</style>